// extracted by mini-css-extract-plugin
export default {"container":"Result_container__7lA9a","item":"Result_item__cLE8s","newlink":"Result_newlink__oWOD+"};